import React, { lazy } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";

import SplachScreen from "../components/splachScreen";
import SplachScreenTeacher from "../components/splachScreenTeacher";
import SplachScreenStudent from "../components/splachScreenStudent";

import { generalRoutes, specialRoutes } from "./general.route";
import { studentRoutes } from "./student.route";
import { teacherRoutes } from "./teacher.route";

const NotFound = lazy(() => import("../pages/notFound"));

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* Common Routes */}
      <Route element={<SplachScreen />}>
        {generalRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}
      </Route>

      {/* Student Routes */}
      <Route element={<SplachScreenStudent />}>
        {studentRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}
      </Route>

      {/* Teacher Routes */}
      <Route element={<SplachScreenTeacher />}>
        {teacherRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}
      </Route>

      {specialRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={<route.component />}
        />
      ))}

      <Route path="/*" element={<NotFound />} />
    </>
  )
);

export default router;
